import i18n from "@/libs/i18n";
export default [
  {
    get header() {
      return i18n.t("bloodBank.blood-bank");
    },
    permission: "get-bloodBottle",
    role: "BloodBank",
  },
  {
    get title() {
      return i18n.t("bloodBank.blood-store");
    },
    route: "blood-store",
    icon: "HomeIcon",
    permission: "get-bloodBottle",
    role: "BloodBank",
  },
  {
    get title() {
      return i18n.t("bloodBank.blood-transfusions");
    },
    route: "blood-transfusions",
    icon: "HomeIcon",
    permission: "get-bloodTransfusion",
    role: "BloodBank",
  },
];
